import React, { Component } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import '../css/InfoPanel.css'
import { NotificationsChart } from './NotificationsChart'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';

class InfoPanel extends Component {


    constructor(props) {
        super(props);
    }

    render() {

        const notifications = this.props.notificationsData;
        const EventNotifiedCount = notifications.length > 0 ? notifications.map(item => item.EventNotifiedCount).reduce((prev, next) => prev + next) : 0;
        const EventAcceptedCount = notifications.length > 0 ? notifications.map(item => item.EventAcceptedCount).reduce((prev, next) => prev + next) : 0;
        const EventEditedCount = notifications.length > 0 ? notifications.map(item => item.EventEditedCount).reduce((prev, next) => prev + next) : 0;
        const EventRejectedCount = notifications.length > 0 ? notifications.map(item => item.EventRejectedCount).reduce((prev, next) => prev + next) : 0;

        return (
            <Row className="border rounded-3 shadow-sm bg-white m-0 p-0">

                <Col className="m-0 p-0">
                    <Row className="m-0 p-0 border-bottom py-1">
                        <p className="text-secondary m-0 p-0 text-center font-weight-600 lh-1 py-1 "><i className="bi bi-clipboard-check pe-1"></i>{this.props.t('home.infoPanel.title')}</p>
                    </Row>
                    <Row className="m-0 mx-3 p-0">
                        <Col className="m-1 mx-3 mb-3 p-1 text-center">
                            <p className="mb-4 bg-gray-300 rounded-pill status-desc-font">{this.props.t('home.infoPanel.notified')}</p>
                            <div className="d-inline-flex  text-secondary justify-content-center align-items-center large-num-font border info-btn">
                                <p className="m-0 p-0 lh-1 large-num-font">{EventNotifiedCount}</p>
                                <span className="d-flex p-0 notification-notified info-border-notified rounded-circle info-status-circle"></span>
                            </div>
                        </Col>
                        <Col className="m-1 mx-3 p-1 text-center">
                            <p className="mb-4 bg-gray-300 px-2 rounded-pill status-desc-font">{this.props.t('home.infoPanel.accepted')}</p>
                            <div className="d-inline-flex text-secondary justify-content-center align-items-center border info-btn">
                                <p className="m-0 p-0 lh-1 large-num-font">{EventAcceptedCount}</p>
                                <span className="d-flex p-0 notification-accepted info-border-accepted rounded-circle info-status-circle">{/*<i className="bi bi-bug"></i>*/}</span>

                            </div>
                        </Col>
                        <Col className="m-1 mx-3 p-1 text-center">
                            <p className="mb-4  bg-gray-300 px-2 rounded-pill status-desc-font">{this.props.t('home.infoPanel.edited')}</p>
                            <div className="d-inline-flex  text-secondary justify-content-center align-items-center border info-btn" >
                                <p className="m-0 p-0 lh-1 large-num-font">{EventEditedCount}</p>
                                <span className="d-flex p-0 notification-edited info-border-edited rounded-circle info-status-circle"></span>
                            </div>
                        </Col>
                        <Col className="m-1 mx-3 p-1 text-center">
                            <p className="mb-4 bg-gray-300 px-2 rounded-pill status-desc-font">{this.props.t('home.infoPanel.rejected')}</p>
                            <div className="d-inline-flex  text-secondary justify-content-center align-items-center border info-btn" >
                                <p className="m-0 p-0 lh-1 large-num-font">{EventRejectedCount}</p>
                                <span className="d-flex p-0 notification-rejected info-border-rejected rounded-circle info-status-circle"></span>
                            </div>
                        </Col>
                    </Row>
                </Col> 
            </Row>
        );
    }
}


function withMyHook(Component) {


    return function WrappedComponent(props) {

        const notificationsData = useSelector((state) => state.notification.notificationsData);
        const userData = useSelector((state) => state.currentUser.userData);
        const { t } = useTranslation();

        return <Component {...props} userData={userData} notificationsData={notificationsData} t={t} />
    }
}

export default withMyHook(InfoPanel)
